import type { Package } from 'types/Package.ts';
import { useBatchResourcePermissions } from '#admin/hook/useBatchResourcePermissions.tsx';

type PackagePermissionOperations = 'TrackerAssign';

export const usePackagePermissions = (packages: Package[], operations: PackagePermissionOperations[] = ['TrackerAssign']) => {
  const resources = packages.map((pkg) => ({
    resourceId: pkg.id,
    operations,
  }));

  const { getPermission, isLoading, error } = useBatchResourcePermissions(resources);

  const getPackagePermission = (packageId: string, operation: PackagePermissionOperations): boolean | undefined => {
    return getPermission(packageId, operation);
  };

  const canAssignTracker = (pkg: Package): boolean | undefined => {
    return getPackagePermission(pkg.id, 'TrackerAssign');
  };

  return {
    getPackagePermission,
    canAssignTracker,
    isLoading,
    error,
  };
};
